import ContainerHeader from 'components/common/ContainerHeader';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { containerStyles } from 'styles/shared';



const mapStyles: any = [
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5'
      }
    ]
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#616161'
      }
    ]
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f5f5f5'
      }
    ]
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#bdbdbd'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee'
      }
    ]
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#757575'
      }
    ]
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e5e5e5'
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e'
      }
    ]
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff'
      }
    ]
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#757575'
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dadada'
      }
    ]
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#616161'
      }
    ]
  },
  {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e'
      }
    ]
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e5e5e5'
      }
    ]
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#c9c9c9'
      }
    ]
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e'
      }
    ]
  }
];

const MapPanelContainer = styled.div`
  width: 54.4rem;
  height: 26rem;
  margin-bottom: 5rem;
  ${containerStyles};
  position: relative;
`;

const ContainerHeaderOverride = styled(ContainerHeader)`
  height: 13.7rem;
  padding: 4rem 4.8rem;
  background: linear-gradient(181.37deg, #ffffff 31.07%, rgba(255, 255, 255, 0) 98.83%);
  position: relative;
  z-index: 10;
  border-top-left-radius: 3rem;
  border-top-right-radius: 3rem;
`;

const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  background: transparent;
  position: absolute;
  top: 0;
  left: 0;
  display: ${props => (props.visible ? 'initial' : 'none')};
  border-radius: 3rem;
`;

MapPanel.propTypes = {
  coordinates: PropTypes.object
};


function MapPanel({coordinates}) {
  const [map, setMap] = useState<any>(null);

  const initRef = useCallback(node => {
    if (node !== null) {
      initMap(node);
    }
  }, []);

  useEffect(() => {
    if (!map || !coordinates) return;

    addLatLng();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, coordinates]);

  function initMap(element) {
    if (typeof google === "undefined") {
      return;
    }
    
    let map: any = new google.maps.Map(element, {
      zoom: 12,
      styles: mapStyles,
      disableDefaultUI: true,
      gestureHandling: 'greedy'
    });

    setMap(map);
  }

  function addLatLng() {
    let latLng = new window.google.maps.LatLng(coordinates.latitude, coordinates.longitude);

    //dynamically change map center
    map.setCenter(latLng);

    const image = {
      url: '/images/map-marker.svg',
      origin: new google.maps.Point(0, 0),
      // The anchor for this image is the base of the flagpole at (0, 32).
      anchor: new google.maps.Point(51.5, 51.5)
    };

    // Add a new marker at the new plotted point on the polyline.
    new window.google.maps.Marker({
      position: latLng,
      map,
      icon: image
    });
  }

  function render() {
    let visible = coordinates ? true : false;

    return (
      <MapPanelContainer>
        <ContainerHeaderOverride>Map</ContainerHeaderOverride>

        <MapContainer ref={initRef} id="destination-map" visible={visible} />
      </MapPanelContainer>
    );
  }

  return render();
}

export default MapPanel;
